import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "ElementCount";
var classes = {
    count: "".concat(PREFIX, "-count"),
    selection: "".concat(PREFIX, "-selection"),
    selectionTitle: "".concat(PREFIX, "-selectionTitle"),
    icon: "".concat(PREFIX, "-icon")
};
var StyledElementCount = styled(ButtonBase)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(0.5, 1)
        },
        _b["& .".concat(classes.count)] = {
            fontWeight: "bold",
            lineHeight: 1.25
        },
        _b["& .".concat(classes.selection)] = {
            display: "flex",
            alignItems: "center",
            flexDirection: "row"
        },
        _b["& .".concat(classes.selectionTitle)] = {
            marginLeft: theme.spacing(0.5),
            fontWeight: "bold",
            color: theme.palette.primary.main
        },
        _b["& .".concat(classes.icon)] = {
            color: theme.palette.primary.main
        },
        _b);
});

export { classes, StyledElementCount as default };
//# sourceMappingURL=index.styled.js.map
